import { Component, Input } from '@angular/core';

import { PaymentAlipayComponent } from '../../payment-alipay.component';

/**
 * "the_portrait" view of /payment-alipay.
 *
 * Uses <qrcode>, whose colours are configurable, but is still rendered dark-on-light on a
 * white plate to match the other methods and to keep every code scannable.
 */
@Component({
  selector: 'app-payment-alipay-portrait',
  templateUrl: './payment-alipay-portrait.component.html',
  styleUrls: ['./payment-alipay-portrait.component.scss']
})
export class PaymentAlipayPortraitComponent {

  @Input() host!: PaymentAlipayComponent;

}
